"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var de_json_1 = __importDefault(require("./locales/de.json"));
if (typeof window !== "undefined") {
    window.missingTranslations = [];
}
var Localization = /** @class */ (function () {
    function Localization() {
        this.locale = "en";
        this.translations = {};
        this.translationsByLocale = { de: de_json_1.default };
        this.setLocale(Localization.defaultLocale());
    }
    Localization.prototype.getLocale = function () {
        return this.locale;
    };
    Localization.prototype.setLocale = function (locale) {
        this.locale = locale;
        this.updateTranslations();
    };
    Localization.prototype.updateTranslations = function () {
        this.translations = Object.entries(this.translationsByLocale[this.locale] || {}).reduce(function (result, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, result), (_b = {}, _b[key.toLocaleLowerCase()] = value, _b)));
        }, {});
    };
    /**
     *
     * @param {string} locale abbrevation for the language in iso format de,dk,ch,no
     * @param {object} translationObject {"english":"translation"}
     */
    Localization.prototype.addTranslations = function (locale, translationObject) {
        this.translationsByLocale[locale] = __assign(__assign({}, (this.translationsByLocale[locale] || {})), translationObject);
        this.updateTranslations();
    };
    /**
     * You can use it with a string or with a template tag.
     *
     * @example localize('hello') or localize`hello`
     * @param {TemplateStringsArray | string[] | string} strings
     * @param {string[]} variables
     */
    Localization.prototype.localize = function (strings) {
        var variables = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            variables[_i - 1] = arguments[_i];
        }
        var stringInput = typeof strings === "string" ? [strings] : Array.from(strings);
        var templateKey = stringInput.reduce(function (result, string, i) {
            var suffix = i + 1 < stringInput.length && "$" + i;
            if (suffix === false) {
                suffix = "";
            }
            return result + string + suffix;
        }, "");
        var theTranslation = this.translations[templateKey.toLowerCase()];
        var text = theTranslation || templateKey;
        var isDevelopment = process.env.NODE_ENV !== "production";
        if (isDevelopment &&
            this.locale !== "en" &&
            theTranslation === undefined &&
            typeof window !== "undefined") {
            window.missingTranslations.push(templateKey);
            window.missingTranslations = window.missingTranslations.filter(function (v, i, a) { return a.indexOf(v) === i; });
        }
        if (variables.length > 0) {
            variables.forEach(function (value, i) {
                text = text.replace("$" + i, value);
            });
        }
        return text;
    };
    Localization.defaultLocale = function () {
        if (typeof window === "undefined")
            return "de";
        var navigator = window.navigator;
        return ((navigator && navigator.language) ||
            (navigator && navigator["userLanguage"]) ||
            "en")
            .split("-")
            .shift();
    };
    return Localization;
}());
exports.default = Localization;
//# sourceMappingURL=Localization.js.map